import NoteActions from 'actions/NoteActions';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import * as BioentityActions from 'inventory/BioentityActions';
import * as navigation from 'Navigation';
import ensureMutable from 'notebook/store/ensureMutable';
import APIUtil from 'util/APIUtil';

class MetadataTabState extends navigation.TabState {
  override defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Metadata',
      closeable: false,
      preferenceKey: 'metadata',
    };
  }

  override initialize(): void {
    this.loadInventoryFileInfo();
    this.loadMixtureInstructions();
  }

  loadInventoryFileInfo(): void {
    BioentityActions.load(this.get('model').id, {
      bioentityAliasInfos: this.get('model').initialBioentityAliasInfos(),
    });
  }

  loadMixtureInstructions(): void {
    const bioentityModel = this.get('model');
    const modelIsMixture = APIUtil.apiIdToType(bioentityModel.id) === ModelTypeConstants.MIXTURE;
    if (modelIsMixture) {
      const instructions = bioentityModel.getInstructions();
      if (instructions) {
        NoteActions.load(instructions.id, ensureMutable(instructions.noteJson));
      }
    }
  }
}

export default MetadataTabState;
